import React, { lazy, Suspense } from 'react'
import { Route, Switch, Redirect } from 'react-router'

// Page components
import Lee from './../components/pages/mobile/index/lee'
import Home from './../components/pages/mobile/index/index'

// Lazy-loaded Monitor components
const Dstyle = lazy(() =>
  import('./../components/pages/mobile/mi_temp_rh_monitor/Dstyle')
)
const Dspecifications = lazy(() =>
  import('./../components/pages/mobile/mi_temp_rh_monitor/Dspecifications')
)
const Gstyle = lazy(() =>
  import('./../components/pages/mobile/cg_temp_rh_monitor/Gstyle')
)
const Gspecifications = lazy(() =>
  import('./../components/pages/mobile/cg_temp_rh_monitor/Gspecifications')
)
const Lstyle = lazy(() =>
  import('./../components/pages/mobile/lee_temp_rh_monitor/Lstyle')
)
const Lspecifications = lazy(() =>
  import('./../components/pages/mobile/lee_temp_rh_monitor/Lspecifications')
)
// Air and App components
const Air = lazy(() => import('./../components/pages/mobile/air'))
const QingpingPlus = lazy(() =>
  import('./../components/pages/mobile/qingping_plus')
)

// Snow/Air Monitor components
const Sstyle = lazy(() => import('./../components/pages/mobile/snow/Sstyle'))
const Sspecifications = lazy(() =>
  import('./../components/pages/mobile/snow/Sspecifications')
)
const SnowProstyle = lazy(() =>
  import('./../components/pages/mobile/snowpro/overview')
)
const SnowProspecifications = lazy(() =>
  import('./../components/pages/mobile/snowpro/specifications')
)

// Device-specific components
const Danystyle = lazy(() => import('./../components/pages/mobile/dany/Sstyle'))
const Danyspecifications = lazy(() =>
  import('./../components/pages/mobile/dany/Sspecifications')
)
const Dk2style = lazy(() => import('./../components/pages/mobile/duck2/Sstyle'))
const Dk2specifications = lazy(() =>
  import('./../components/pages/mobile/duck2/Sspecifications')
)
const Dk3style = lazy(() => import('./../components/pages/mobile/duck3/Sstyle'))
const Dk3specifications = lazy(() =>
  import('./../components/pages/mobile/duck3/Sspecifications')
)
const GooseDuck3Style = lazy(() =>
  import('./../components/pages/mobile/temp-rh-monitor-3/index')
)
const GooseDuck3Specifications = lazy(() =>
  import('./../components/pages/mobile/temp-rh-monitor-3/Sspecifications')
)
const Hodorstyle = lazy(() =>
  import('./../components/pages/mobile/hodor/Sstyle')
)
const Hodorspecifications = lazy(() =>
  import('./../components/pages/mobile/hodor/Sspecifications')
)
const Parrotstyle = lazy(() =>
  import('./../components/pages/mobile/parrot/Sstyle')
)
const Parrotspecifications = lazy(() =>
  import('./../components/pages/mobile/parrot/Sspecifications')
)
const Chickenstyle = lazy(() =>
  import('./../components/pages/mobile/chicken/Sstyle')
)
const Chickenspecifications = lazy(() =>
  import('./../components/pages/mobile/chicken/Sspecifications')
)

// Privacy components
const Eprivacy = lazy(() => import('./../components/pages/mobile/privacy'))
const Gprivacy = lazy(() => import('./../components/pages/mobile/Gprivacy'))
const Bprivacy = lazy(() => import('./../components/pages/mobile/Bprivacy'))
const Sprivacy = lazy(() => import('./../components/pages/mobile/Sprivacy'))
const Hprivacy = lazy(() => import('./../components/pages/mobile/Hprivacy'))
const Pprivacy = lazy(() => import('./../components/pages/mobile/Pprivacy'))
const Dprivacy = lazy(() => import('./../components/pages/mobile/Dprivacy'))
const DNprivacy = lazy(() => import('./../components/pages/m2p/DanyPrivacy'))

const Doveprivacy = lazy(() =>
  import('./../components/pages/mobile/DovePrivacy')
)
const Snowprivacy = lazy(() =>
  import('./../components/pages/mobile/SnowPrivacy')
)
const Chickenprivacy = lazy(() =>
  import('./../components/pages/mobile/ChickenPrivacy')
)

// Utility pages
const Share = lazy(() => import('./../components/pages/mobile/share'))
const ContactUs = lazy(() => import('./../components/pages/mobile/contact'))
// const Store = lazy(() => import('./../components/pages/mobile/store'))

// Additional Monitor components
const Pstyle = lazy(() =>
  import('./../components/pages/mobile/lora_temp_rh_monitor/Pstyle')
)
const Pspecifications = lazy(() =>
  import('./../components/pages/mobile/lora_temp_rh_monitor/Pspecifications')
)
const Cstyle = lazy(() =>
  import('./../components/pages/mobile/co2_temp_rh_monitor/Pstyle')
)
const Cspecifications = lazy(() =>
  import('./../components/pages/mobile/co2_temp_rh_monitor/Pspecifications')
)
const Wstyle = lazy(() =>
  import('./../components/pages/mobile/wall-socket-thermometer/Pstyle')
)
const Wspecifications = lazy(() =>
  import('./../components/pages/mobile/wall-socket-thermometer/Pspecifications')
)
const Fstyle = lazy(() => import('./../components/pages/mobile/frog/Pstyle'))
const Fspecifications = lazy(() =>
  import('./../components/pages/mobile/frog/Pspecifications')
)
const AirPrivacy = lazy(() =>
  import('./../components/pages/mobile/air_privacy')
)
const LeeGuitarsPrivacy = lazy(() =>
  import('./../components/pages/mobile/lee_guitars_privacy')
)
const iotPrivacy = lazy(() =>
  import('./../components/pages/mobile/iot_privacy')
)
const iotWebsitePrivacy = lazy(() =>
  import('./../components/pages/mobile/iot_website_privacy')
)
const AirAgreement = lazy(() =>
  import('./../components/pages/mobile/air_agreement')
)
const AllPrivacy = lazy(() =>
  import('./../components/pages/mobile/all_privacy')
)

// About and Info pages
const AboutUs = lazy(() => import('./../components/pages/mobile/about_us'))
const Iot = lazy(() => import('./../components/pages/mobile/iot'))
const PresetApps = lazy(() =>
  import('./../components/pages/mobile/preset_apps')
)
const Clock = lazy(() => import('./../components/pages/mobile/clock'))
const Spstyle = lazy(() =>
  import('./../components/pages/mobile/sparrow/Overview')
)
const Spspecifications = lazy(() =>
  import('./../components/pages/mobile/sparrow/Specifications')
)
const DoveOverview = lazy(() =>
  import('./../components/pages/mobile/dove/overview')
)
const DoveSpecifications = lazy(() =>
  import('./../components/pages/mobile/dove/specifications')
)
const MiTranslator = lazy(() =>
  import('./../components/pages/pc/mi_translator')
)

// EU Documentation
const EuDoc = lazy(() => import('./../components/pages/mobile/eu_doc'))

const MagpieEuDoc = lazy(() =>
  import('./../components/pages/pc/eu_doc_pages/magpie')
)
const DanyEuDoc = lazy(() =>
  import('./../components/pages/pc/eu_doc_pages/dany')
)
const ChickenEuDoc = lazy(() =>
  import('./../components/pages/pc/eu_doc_pages/chicken')
)
const DoveEuDoc = lazy(() =>
  import('./../components/pages/pc/eu_doc_pages/dove')
)
const SparrowEuDoc = lazy(() =>
  import('./../components/pages/pc/eu_doc_pages/sparrow')
)
const HodorEuDoc = lazy(() =>
  import('./../components/pages/pc/eu_doc_pages/hodor')
)
const ParrotEuDoc = lazy(() =>
  import('./../components/pages/pc/eu_doc_pages/parrot')
)
const GooseHEuDoc = lazy(() =>
  import('./../components/pages/pc/eu_doc_pages/goose_h')
)
const Duck2EuDoc = lazy(() =>
  import('./../components/pages/pc/eu_doc_pages/duck2')
)
const Duck2CEuDoc = lazy(() =>
  import('./../components/pages/pc/eu_doc_pages/duck2_c')
)
const Duck3EuDoc = lazy(() =>
  import('./../components/pages/pc/eu_doc_pages/duck3')
)
const Duck3CEuDoc = lazy(() =>
  import('./../components/pages/pc/eu_doc_pages/duck3_c')
)
const GooseMEuDoc = lazy(() =>
  import('./../components/pages/pc/eu_doc_pages/goose_m')
)
const FrogEuDoc = lazy(() =>
  import('./../components/pages/pc/eu_doc_pages/frog')
)
const SnowEuDoc = lazy(() =>
  import('./../components/pages/pc/eu_doc_pages/snow')
)

const Comparison = lazy(() => import('../components/pages/mobile/comparison/humiture'))
const ComparisonAir = lazy(() => import('../components/pages/mobile/comparison/air'))
const Frogs = lazy(() => import('./../components/pages/mobile/frogs/index'))
const FrogsSpecifications = lazy(() =>
  import('./../components/pages/mobile/frogs/ForgsSpecifications')
)
const Robb = lazy(() => import('./../components/pages/mobile/robb/index'))
const RobbSpecifications = lazy(() =>
  import('./../components/pages/mobile/robb/ForgsSpecifications')
)
const Goose3TStyle = lazy(() => import('./../components/pages/mobile/goose3t/Sstyle'))
const Goose3TSpecifications = lazy(() => import('./../components/pages/mobile/goose3t/Sspecifications'))

const redirectRoutes = [
  { path: '/store', to: '/' },
  { path: '/plus', to: '/home-app' },
  { path: '/plus/privacy', to: '/home-app/privacy' },
  { path: '/mi-temp-rh-monitor', to: '/mi-temp-rh-monitor/overview' },
  { path: '/temp-rh-monitor', to: '/temp-rh-monitor/overview' },
  { path: '/lee-guitars-thermo-hygrometer', to: '/lee-guitars-thermo-hygrometer/overview' },
  { path: '/mi-multifunction-air-monitor', to: '/mi-multifunction-air-monitor/privacy' },
  { path: '/apps', to: '/apps/qingpingplus' },
  { path: '/temp-rh-monitor-pro-s', to: '/temp-rh-monitor-pro-s/overview' },
  { path: '/temp-rh-monitor-pro-e', to: '/temp-rh-monitor-pro-e/overview' },
  { path: '/air-monitor', to: '/air-monitor/overview' },
  { path: '/air-monitor-2', to: '/air-monitor-2/overview' },
  { path: '/air-monitor-lite', to: '/air-monitor-lite/overview' },
  { path: '/temp-rh-monitor-3', to: '/temp-rh-monitor-3/overview' },

  { path: '/bluetooth-gateway', to: '/bluetooth-gateway/overview' },
  { path: '/indoor-environment-monitor', to: '/indoor-environment-monitor/overview' },
  { path: '/bluetooth-alarm-clock', to: '/bluetooth-alarm-clock/overview' },
  { path: '/mi-translator', to: '/mi-translator/overview' },
  // -- 新增以下重定向 --
  { path: '/lee-guitars/app', to: '/lee-guitars/app/overview' },
  { path: '/co2-temp-rh-monitor', to: '/co2-temp-rh-monitor/overview' },
  { path: '/wall-socket-thermometer', to: '/wall-socket-thermometer/overview' },
  { path: '/temp-rh-monitor-lite-3', to: '/temp-rh-monitor-lite-3/overview' },
  { path: '/temp-rh-monitor-lite', to: '/temp-rh-monitor-lite/overview' },
  { path: '/door-window-sensor', to: '/door-window-sensor/overview' },
  { path: '/motion-light-sensor', to: '/motion-light-sensor/overview' },
  { path: '/bluetooth-clock', to: '/bluetooth-clock/overview' },
  { path: '/multi-role-monitor', to: '/multi-role-monitor/overview' },
]

const routeConfigs = [
  { path: '/lee-guitars/app/overview', exact: true, component: Lee },
  { path: '/', exact: true, component: Home },
  { path: '/mi-temp-rh-monitor/overview', exact: true, component: Dstyle },
  { path: '/mi-temp-rh-monitor/specifications', exact: true, component: Dspecifications },
  { path: '/temp-rh-monitor/overview', exact: true, component: Gstyle },
  { path: '/temp-rh-monitor/specifications', exact: true, component: Gspecifications },
  { path: '/lee-guitars-thermo-hygrometer/overview', exact: true, component: Lstyle },
  { path: '/lee-guitars-thermo-hygrometer/specifications', exact: true, component: Lspecifications },
  { path: '/mi-temp-rh-monitor/privacy', exact: true, component: Eprivacy },
  { path: '/temp-rh-monitor/privacy', exact: true, component: Gprivacy },
  { path: '/mi-multifunction-air-monitor/privacy', exact: true, component: Bprivacy },
  { path: '/home-app', exact: true, component: Air },
  { path: '/apps/qingpingplus', exact: true, component: QingpingPlus },
  { path: '/air', exact: true, component: Air },
  { path: '/temp-rh-monitor-pro-s/overview', exact: true, component: Pstyle },
  { path: '/temp-rh-monitor-pro-s/specifications', exact: true, component: Pspecifications },
  { path: '/co2-temp-rh-monitor/overview', exact: true, component: Cstyle },
  { path: '/co2-temp-rh-monitor/specifications', exact: true, component: Cspecifications },
  { path: '/wall-socket-thermometer/overview', exact: true, component: Wstyle },
  { path: '/wall-socket-thermometer/specifications', exact: true, component: Wspecifications },
  { path: '/temp-rh-monitor-pro-e/overview', exact: true, component: Fstyle },
  { path: '/temp-rh-monitor-pro-e/specifications', exact: true, component: Fspecifications },
  { path: '/air-monitor/overview', exact: true, component: Sstyle },
  { path: '/air-monitor/specifications', exact: true, component: Sspecifications },
  { path: '/air-monitor-2/overview', exact: true, component: SnowProstyle },
  { path: '/air-monitor-2/specifications', exact: true, component: SnowProspecifications },
  { path: '/air-monitor-lite/overview', exact: true, component: Danystyle },
  { path: '/air-monitor-lite/specifications', exact: true, component: Danyspecifications },
  { path: '/temp-rh-monitor-lite/overview', exact: true, component: Dk2style },
  { path: '/temp-rh-monitor-lite/specifications', exact: true, component: Dk2specifications },
  { path: '/temp-rh-monitor-lite-3/overview', exact: true, component: Dk3style },
  { path: '/temp-rh-monitor-lite-3/specifications', exact: true, component: Dk3specifications },
  { path: '/temp-rh-monitor-3/overview', exact: true, component: GooseDuck3Style },
  { path: '/temp-rh-monitor-3/specifications', exact: true, component: GooseDuck3Specifications },
  { path: '/door-window-sensor/overview', exact: true, component: Hodorstyle },
  { path: '/door-window-sensor/specifications', exact: true, component: Hodorspecifications },
  { path: '/motion-light-sensor/overview', exact: true, component: Parrotstyle },
  { path: '/motion-light-sensor/specifications', exact: true, component: Parrotspecifications },
  { path: '/bluetooth-clock/overview', exact: true, component: Chickenstyle },
  { path: '/bluetooth-clock/specifications', exact: true, component: Chickenspecifications },
  { path: '/air-app-and-air-monitor', exact: true, component: Share },
  { path: '/air-app-and-temp-rh-monitor', exact: true, component: Share },
  { path: '/air-app-and-temp-rh-barometer', exact: true, component: Share },
  { path: '/contact', exact: true, component: ContactUs },
  // { path: '/store', exact: true, component: Store },
  { path: '/air/privacy', exact: true, component: AirPrivacy },
  { path: '/lee-guitars/privacy', exact: true, component: LeeGuitarsPrivacy },
  { path: '/iot/privacy', exact: true, component: iotPrivacy },
  { path: '/iot-website/privacy', exact: true, component: iotWebsitePrivacy },
  { path: '/home-app/privacy', exact: true, component: AirPrivacy },
  { path: '/air/agreement', exact: true, component: AirAgreement },
  { path: '/privacy', exact: true, component: AllPrivacy },
  { path: '/about-us', exact: true, component: AboutUs },
  { path: '/iot', exact: true, component: Iot },
  { path: '/qingpingiot', exact: true, component: Iot },
  { path: '/mi-translator/preset-apps', exact: true, component: PresetApps },
  { path: '/bluetooth-gateway/overview', exact: true, component: Spstyle },
  { path: '/bluetooth-gateway/specifications', exact: true, component: Spspecifications },
  { path: '/bluetooth-gateway/privacy', exact: true, component: Sprivacy },
  { path: '/door-window-sensor/privacy', exact: true, component: Hprivacy },
  { path: '/motion-light-sensor/privacy', exact: true, component: Pprivacy },
  { path: '/temp-rh-monitor-lite/privacy', exact: true, component: Dprivacy },
  { path: '/duck3/privacy', exact: true, component: Dprivacy },
  { path: '/air-monitor-lite/privacy', exact: true, component: DNprivacy },
  { path: '/alarm-clock/privacy', exact: true, component: Doveprivacy },
  { path: '/air-monitor/privacy', exact: true, component: Snowprivacy },
  { path: '/bluetooth-clock/privacy', exact: true, component: Chickenprivacy },
  { path: '/bluetooth-alarm-clock/apps', exact: true, component: Clock },
  { path: '/bluetooth-alarm-clock/overview', exact: true, component: DoveOverview },
  { path: '/bluetooth-alarm-clock/specifications', exact: true, component: DoveSpecifications },
  { path: '/mi_translator/preset_apps', exact: true, component: MiTranslator },
  { path: '/eu-declarations', exact: true, component: EuDoc },
  { path: '/lee-guitars-thermo-hygrometer/eu-declaration', exact: true, component: MagpieEuDoc },
  { path: '/air-monitor-lite/eu-declaration', exact: true, component: DanyEuDoc },
  { path: '/bluetooth-clock/eu-declaration', exact: true, component: ChickenEuDoc },
  { path: '/bluetooth-alarm-clock/eu-declaration', exact: true, component: DoveEuDoc },
  { path: '/bluetooth-gateway/eu-declaration', exact: true, component: SparrowEuDoc },
  { path: '/door-window-sensor/eu-declaration', exact: true, component: HodorEuDoc },
  { path: '/motion-light-sensor/eu-declaration', exact: true, component: ParrotEuDoc },
  { path: '/temp-rh-monitor-h/eu-declaration', exact: true, component: GooseHEuDoc },
  { path: '/temp-rh-monitor-lite/eu-declaration', exact: true, component: Duck2EuDoc },
  { path: '/temp-rh-monitor-lite-c/eu-declaration', exact: true, component: Duck2CEuDoc },
  { path: '/duck3/eu-declaration', exact: true, component: Duck3EuDoc },
  { path: '/duck3-c/eu-declaration', exact: true, component: Duck3CEuDoc },
  { path: '/temp-rh-monitor/eu-declaration', exact: true, component: GooseMEuDoc },
  { path: '/temp-rh-monitor-pro-e/eu-declaration', exact: true, component: FrogEuDoc },
  { path: '/air-monitor/eu-declaration', exact: true, component: SnowEuDoc },
  { path: '/multi-role-monitor/overview', exact: true, component: Frogs },
  { path: '/multi-role-monitor/specifications', exact: true, component: FrogsSpecifications },
  { path: '/indoor-environment-monitor/overview', exact: true, component: Robb },
  { path: '/indoor-environment-monitor/specifications', exact: true, component: RobbSpecifications },
  { path: '/comparison-air-monitor', exact: true, component: ComparisonAir },
  { path: '/comparison-temp-rh-monitor', exact: true, component: Comparison },
  { path: '/temp-rh-monitor-3t/overview', exact: true, component: Goose3TStyle },
  { path: '/temp-rh-monitor-3t/specifications', exact: true, component: Goose3TSpecifications }
]

const Routers = () => (
  <Suspense fallback={<div></div>}>
    <Switch>
      {redirectRoutes.map(({ path, to }) => (
        <Route
          key={`redirect:${path}`}
          path={path}
          exact
          render={({ location }) => <Redirect to={`${to}${location.search}`} />}
        ></Route>
      ))}
      {routeConfigs.map(({ path, exact, component }) => (
        <Route key={path} path={path} exact={!!exact} component={component} />
      ))}
    </Switch>
  </Suspense>
)

export default Routers
